import type { CustomProduct, ProductGroup } from "@apptus/esales-api";

import type { MarketConfiguration } from "@/config/markets/const";

import { mapElevateProduct } from "./mapElevateProducts";
import { ProductConfig } from "./utils";

export default function mapElevateProductGroups({
  productGroups,
  marketConfig,
  config = {
    allowDefault: true,
  },
}: {
  productGroups: ProductGroup[];
  marketConfig: MarketConfiguration;
  config?: ProductConfig;
}) {
  return productGroups.map((productGroup) => {
    const products = productGroup.products as CustomProduct[];
    const [product] = products;

    return mapElevateProduct({
      product,
      marketConfig,
      config: {
        ...config,
        hasVariants: productGroup.products.length > 1,
      },
    });
  });
}
